export enum Routes {
  Home = '/',
  Homes = '/homes',
  // TODO: Change route search to route hotel on the entire site
  Search = '/hotel',
  Cruises = '/cruise',
  Error = '/error',
  Getaway = '/getaway',
  GetawayCondo = '/getaway/condo',
  GetawayList = '/getaway-list',
  GetawayDetails = '/getaway-details',
  GetawayBookingPage = '/getaway-booking',
  SearchResult = '/result',
  Hotel = '/hotel',
  AdminHotel = '/bookings-admin-hotel',
  AllInclusive = '/all-inclusives',
  AllInclusivesSubmitRequest = '/all-inclusives/submit-request',
  Book = '/book',
  Condo = '/condo',
  CondoSearch = '/condo/deals',
  AdminCondo = '/bookings-admin-condo',
  UnitBook = '/unit-book',
  AdminPage = '/admin-page',
  PriceRules = '/admin-page/business-rules/price-rules',
  PresentationRules = '/admin-page/business-rules/presentation-rules',
  AllBookings = '/admin-page/all-bookings',
  BookingDetails = '/admin-page/all-bookings/booking',
  OrderDetails = '/admin-page/all-bookings/order',
  BusinessRules = '/business-rules',
  NewRule = '/admin-page/business-rules/price-rules/new-rule',
  NewPresentationRule = '/admin-page/business-rules/presentation-rules/new-rule',
  ActivityUsers = '/admin-page/business-rules/price-rules/activity',
  AdminHotelBookingDetails = '/admin-page/all-bookings/hotel-booking',
  ReservationCancellation = '/reservation-cancellation',
  RequestCancelReservation = '/request-cancel-reservation',
  AmericanLifestyle = '/magazine',
  ConciergeTeam = '/concierge-travel-team',
  MemberStories = '/member-stories',
  Resources = '/travel-resources',
  DailyBenefits = '/daily-benefits',
  MemberVideos = '/member-videos',
  ContactUs = '/contact-us',
  MasterClassesRegister = '/master-classes-register',
  PersonalInfo = '/personal-info',
  Security = '/security',
  PromotionDetails = '/promotion',
  PrivacyPolicy = '/privacy-policy',
  PriceMatch = '/price-match',
  Faq = '/faq',
}

export enum Urls {
  Hotels = '/api/Hotels/search/page',
  GetHotels = '/api/hotels',
  Locations = '/api/Locations/Search',
  NavigationItems = '/api/Sso/Menu',
  Suppliers = '/api/suppliers',
  HotelDetails = '/api/hotels/hotel',
  AdminHotelDetails = '/api/admin/condo/condobookings/hotel',
  HotelAutocomplete = '/api/hotels/hotel/autocomplete',
  BookingSummary = '/api/hotels/hotel/booking-summary',
  HotelRooms = '/api/hotels/search/id',
  HotelsMap = '/api/hotels/search/area',
  TrustYou = 'https://api.trustyou.com/hotels',
  Getaways = '/api/deals',
  HotelRedeemCode = '/api/hotels/redeem-code',
  HotelRemoveCode = '/api/hotels/cancel-redeem-code',
  CondoRedeemCode = '/api/condos/redeem-code',
  CondoRemoveCode = '/api/condos/cancel-redeem-code',
  BookPackageWithCard = '/api/hotels/book-package-with-card',
  CondosSearchAnytime = '/api/condos/search/anytime',
  CondosSearchAnytimePagination = '/api/condos/search/anytime/page',
  CondosSearchStrict = '/api/condos/search/strict',
  CondosSearchStrictPagination = '/api/condos/search/strict/page',
  CondosSearchFlexible = '/api/condos/search/flexible',
  CondosSearchFlexiblePagination = '/api/condos/search/flexible/page',
  CondosLocations = '/api/condos/locations',
  CondosLocationsPopularDestinations = '/api/condos/locations/popular',
  HotelLocationsPopularDestinations = '/api/hotels/locations/popular',
  CondosRecommendedLocations = '/api/condos/locations/recommended',
  CondosRecentSearches = '/api/condos/recent-searches',
  CondoDetails = '/api/condos/details',
  AdminCondoDetails = '/api/admin/condo/condobookings/condo',
  CondoUnits = '/api/condos/search/units',
  CondoBookingSummary = '/api/condos/booking-summary',
  HotelPriceRules = '/api/admin/hotel/pricerules',
  CondoPresentationRules = '/api/admin/condo/presentationrules',
  PresentationRules = '/api/admin/search-rules',
  SiteId = 'api/new-price-rule/site-id',
  ChangePriceRule = 'api/change-price-rule',
  ActivityUsers = 'api/activity',
  CheckinStatus = 'api/condos/checkin-status',
  CondoCountries = 'api/condos/countries',
  CondoBook = '/api/condos/book',
  AdminBooking = '/api/admin/condo/condobookings',
  AdminBookingSearch = '/api/admin/condo/condobookings/search',
  AdminBookingRetryVoid = '/api/admin/condo/condobookings/retry-void',
  AdminBookingRetryCapture = '/api/admin/condo/condobookings/retry-capture',
  CondoBookingsSubStatuses = '/api/admin/condo/condobookings/substatuses',
  CondoBookingsExportCsv = '/api/admin/condo/condobookings/export',
  AdminCondoNotification = 'api/admin/condo/notification',
  AdminHotelNotification = 'api/admin/hotel/notification',
  MarkAsCancelled = '/api/admin/condo/condobookings/mark-as-cancelled',
  AdminSuppliers = '/api/admin/hotel/suppliers',
  HotelBookingsExportCsv = '/api/admin/hotel/hotelbookings/export',
  HotelBookings = 'api/admin/hotel/hotelbookings',
  SearchHotelBookings = 'api/admin/hotel/hotelbookings/search',
  ExportHotelBookings = 'api/admin/hotel/hotelbookings/export',
  HotelBookingsOrderDetails = 'api/admin/hotel/hotelbookings/order-details',
  HotelBookingsOrderDetailsCancel = 'api/admin/hotel/hotelbookings/cancel',
  reservationCancellationDetails = 'api/bookings/reservation-details',
  requestCancelReservation = 'api/bookings/request-cancel-reservation',
  cancelReservation = '/api/bookings/cancel-reservation',
  supportPhone = 'api/support/phone',
  Benefits = '/api/sso/benefits',
  Magazine = 'api/external/magazine',
  Promotions = '/api/promotions',
  NotificationBar = 'api/external/notification-bar',
  HotelsRecentSearches = '/api/hotels/recent-searches',
  Deals = '/api/deals',
  CurrentUser = '/api/sso/currentuser',
  MemberStories = 'api/external/member-stories',
  MemberVideos = 'https://rsistaticdata.s3.amazonaws.com/membervideos',
  PersonalDetails = '/api/sso/personal-details',
}

